export var INBOX_HELP = {
    title: 'ui-czna-authorities.nav.inbox.about.title',
    intro: 'ui-czna-authorities.nav.inbox.help.intro',
    sections: [
        {
            heading: 'ui-czna-authorities.nav.inbox.about.why',
            items: [
                { term: 'ui-czna-authorities.nav.inbox.returned', text: 'ui-czna-authorities.nav.inbox.help.returned' },
                { term: 'ui-czna-authorities.nav.inbox.toReview', text: 'ui-czna-authorities.nav.inbox.help.toReview' },
            ],
        },
        {
            heading: 'ui-czna-authorities.nav.inbox.about.work',
            items: [
                { term: 'ui-czna-authorities.nav.inbox.order', text: 'ui-czna-authorities.nav.inbox.help.order' },
                { term: 'ui-czna-authorities.nav.inbox.filter', text: 'ui-czna-authorities.nav.inbox.help.filter' },
            ],
        },
    ],
};
export var REVIEW_QUEUE_HELP = {
    title: 'ui-czna-authorities.nav.reviewQueue.about.title',
    intro: 'ui-czna-authorities.nav.reviewQueue.help.intro',
    sections: [
        {
            heading: 'ui-czna-authorities.nav.reviewQueue.about.shows',
            items: [
                { term: 'ui-czna-authorities.nav.reviewQueue.localReview', text: 'ui-czna-authorities.nav.reviewQueue.help.localReview' },
                { term: 'ui-czna-authorities.nav.reviewQueue.nationalReview', text: 'ui-czna-authorities.nav.reviewQueue.help.nationalReview' },
                { term: 'ui-czna-authorities.nav.reviewQueue.vocabularyTerms', text: 'ui-czna-authorities.nav.reviewQueue.help.vocabularyTerms' },
                { term: 'ui-czna-authorities.nav.reviewQueue.admin', text: 'ui-czna-authorities.nav.reviewQueue.help.admin' },
            ],
        },
        {
            heading: 'ui-czna-authorities.nav.reviewQueue.about.work',
            items: [
                { term: 'ui-czna-authorities.nav.reviewQueue.order', text: 'ui-czna-authorities.nav.reviewQueue.help.order' },
                { term: 'ui-czna-authorities.nav.reviewQueue.filter', text: 'ui-czna-authorities.nav.reviewQueue.help.filter' },
                { term: 'ui-czna-authorities.nav.reviewQueue.inbox', text: 'ui-czna-authorities.nav.reviewQueue.help.inbox' },
            ],
        },
    ],
};
export var AUTHORITIES_HELP = {
    title: 'ui-czna-authorities.nav.authorities.about.title',
    intro: 'ui-czna-authorities.nav.authorities.help.intro',
    sections: [
        {
            heading: 'ui-czna-authorities.nav.authorities.about.shows',
            items: [
                { term: 'ui-czna-authorities.nav.authorities.proposal', text: 'ui-czna-authorities.nav.authorities.help.proposal' },
                { term: 'ui-czna-authorities.nav.authorities.author', text: 'ui-czna-authorities.nav.authorities.help.author' },
            ],
        },
        {
            heading: 'ui-czna-authorities.nav.authorities.about.work',
            items: [
                { term: 'ui-czna-authorities.nav.authorities.filters', text: 'ui-czna-authorities.nav.authorities.help.filters' },
                { term: 'ui-czna-authorities.nav.authorities.search', text: 'ui-czna-authorities.nav.authorities.help.search' },
                { term: 'ui-czna-authorities.nav.authorities.fieldQuery', text: 'ui-czna-authorities.nav.authorities.help.fieldQuery' },
            ],
        },
    ],
};
export var HEADINGS_HELP = {
    title: 'ui-czna-authorities.nav.headings.about.title',
    intro: 'ui-czna-authorities.nav.headings.help.intro',
    sections: [
        {
            heading: 'ui-czna-authorities.nav.headings.about.shows',
            items: [
                { term: 'ui-czna-authorities.nav.headings.preferred', text: 'ui-czna-authorities.nav.headings.help.preferred' },
                { term: 'ui-czna-authorities.nav.headings.variant', text: 'ui-czna-authorities.nav.headings.help.variant' },
                { term: 'ui-czna-authorities.nav.headings.details', text: 'ui-czna-authorities.nav.headings.help.details' },
            ],
        },
        {
            heading: 'ui-czna-authorities.nav.headings.about.work',
            items: [
                { term: 'ui-czna-authorities.nav.headings.filters', text: 'ui-czna-authorities.nav.headings.help.filters' },
                { term: 'ui-czna-authorities.nav.headings.jumpTo', text: 'ui-czna-authorities.nav.headings.help.jumpTo' },
                { term: 'ui-czna-authorities.nav.headings.open', text: 'ui-czna-authorities.nav.headings.help.open' },
            ],
        },
    ],
};
export var VOCABULARIES_HELP = {
    title: 'ui-czna-authorities.nav.vocabularies.about.title',
    intro: 'ui-czna-authorities.nav.vocabularies.help.intro',
    sections: [
        {
            heading: 'ui-czna-authorities.nav.vocabularies.about.shows',
            items: [
                { term: 'ui-czna-authorities.nav.vocabularies.code', text: 'ui-czna-authorities.nav.vocabularies.help.code' },
                { term: 'ui-czna-authorities.nav.vocabularies.status', text: 'ui-czna-authorities.nav.vocabularies.help.status' },
            ],
        },
        {
            heading: 'ui-czna-authorities.nav.vocabularies.about.work',
            items: [
                { term: 'ui-czna-authorities.nav.vocabularies.select', text: 'ui-czna-authorities.nav.vocabularies.help.select' },
                { term: 'ui-czna-authorities.nav.vocabularies.usage', text: 'ui-czna-authorities.nav.vocabularies.help.usage' },
            ],
        },
    ],
};
/** CZNA-1562 — Nastavení → Sklizeň OAI. */
export var OAI_HARVEST_HELP = {
    title: 'ui-czna-authorities.nav.oaiHarvest.about.title',
    intro: 'ui-czna-authorities.nav.oaiHarvest.help.intro',
    sections: [
        {
            heading: 'ui-czna-authorities.nav.oaiHarvest.about.shows',
            items: [
                { term: 'ui-czna-authorities.nav.oaiHarvest.summary', text: 'ui-czna-authorities.nav.oaiHarvest.help.summary' },
                { term: 'ui-czna-authorities.nav.oaiHarvest.verb', text: 'ui-czna-authorities.nav.oaiHarvest.help.verb' },
                { term: 'ui-czna-authorities.nav.oaiHarvest.errorCode', text: 'ui-czna-authorities.nav.oaiHarvest.help.errorCode' },
                { term: 'ui-czna-authorities.nav.oaiHarvest.log', text: 'ui-czna-authorities.nav.oaiHarvest.help.log' },
            ],
        },
        {
            heading: 'ui-czna-authorities.nav.oaiHarvest.about.work',
            items: [
                { term: 'ui-czna-authorities.nav.oaiHarvest.window', text: 'ui-czna-authorities.nav.oaiHarvest.help.window' },
                { term: 'ui-czna-authorities.nav.oaiHarvest.status', text: 'ui-czna-authorities.nav.oaiHarvest.help.status' },
                { term: 'ui-czna-authorities.nav.oaiHarvest.clientIp', text: 'ui-czna-authorities.nav.oaiHarvest.help.clientIp' },
                { term: 'ui-czna-authorities.nav.oaiHarvest.loadMore', text: 'ui-czna-authorities.nav.oaiHarvest.help.loadMore' },
            ],
        },
    ],
};
/**
 * Lead terms that name something the screen itself labels, with that label's id. The help
 * repeats the label rather than reading it, because the editor needs the term next to the
 * text to name the row — `ScreenHelp.test.tsx` keeps the two equal in every locale.
 */
export var TERMS_NAMING_SCREEN_LABELS = {
    'ui-czna-authorities.nav.inbox.about.why': 'ui-czna-authorities.review.queue.column.waitingReason',
    'ui-czna-authorities.nav.inbox.returned': 'ui-czna-authorities.review.waitingReason.RETURNED',
    'ui-czna-authorities.nav.inbox.toReview': 'ui-czna-authorities.review.waitingReason.TO_REVIEW',
    'ui-czna-authorities.nav.reviewQueue.localReview': 'ui-czna-authorities.review.badge.pending',
    'ui-czna-authorities.nav.reviewQueue.nationalReview': 'ui-czna-authorities.review.badge.pendingNational',
    'ui-czna-authorities.nav.reviewQueue.inbox': 'ui-czna-authorities.nav.inbox',
    'ui-czna-authorities.nav.authorities.proposal': 'ui-czna-authorities.authorities.kind.proposal',
    'ui-czna-authorities.nav.authorities.author': 'ui-czna-authorities.authorities.column.author',
    'ui-czna-authorities.nav.authorities.fieldQuery': 'ui-czna-authorities.fieldQuery.toggle',
    'ui-czna-authorities.nav.headings.jumpTo': 'ui-czna-authorities.index.jumpTo.placeholder',
    'ui-czna-authorities.nav.vocabularies.code': 'ui-czna-authorities.vocabularies.list.code',
    'ui-czna-authorities.nav.vocabularies.status': 'ui-czna-authorities.vocabularies.list.status',
    'ui-czna-authorities.nav.vocabularies.usage': 'ui-czna-authorities.vocabularies.usage.open',
    'ui-czna-authorities.nav.oaiHarvest.summary': 'ui-czna-authorities.oaiHarvest.summary.title',
    'ui-czna-authorities.nav.oaiHarvest.verb': 'ui-czna-authorities.oaiHarvest.breakdown.verb.title',
    'ui-czna-authorities.nav.oaiHarvest.errorCode': 'ui-czna-authorities.oaiHarvest.breakdown.errorCode.title',
    'ui-czna-authorities.nav.oaiHarvest.log': 'ui-czna-authorities.oaiHarvest.log.title',
    'ui-czna-authorities.nav.oaiHarvest.window': 'ui-czna-authorities.oaiHarvest.filter.window',
    'ui-czna-authorities.nav.oaiHarvest.status': 'ui-czna-authorities.oaiHarvest.filter.status',
    'ui-czna-authorities.nav.oaiHarvest.clientIp': 'ui-czna-authorities.oaiHarvest.filter.clientIp',
    'ui-czna-authorities.nav.oaiHarvest.loadMore': 'ui-czna-authorities.oaiHarvest.log.loadMore',
};
